/**
 * External Dependencies
 */
import 'jquery';
import Swiper from 'swiper/swiper-bundle';
import 'zeynepjs'

// Expose global scope - Swiper
window.Swiper = Swiper;

$(() => {


    /* ===========================  Sticky Header  ========================== */

    var elementToSticky = 'header';
    $(window).scroll(function () {
        var distanceFromTop = $(this).scrollTop();
        if (distanceFromTop >= 50) {
            $(elementToSticky).addClass('stuck');
        } else {
            $(elementToSticky).removeClass('stuck');
        }
    });



        // init zeynepjs side menu
        var zeynep = $('.zeynep').zeynep({
            // opened: function () {
            //     // log
            //     console.log('the side menu opened')
            // },
            // closed: function () {
            //     // log
            //     console.log('the side menu closed')
            // },
        })

        // dynamically bind 'closing' event
        // zeynep.on('closing', function () {
        //     // log
        //     console.log('this event is dynamically binded')
        // })

        // handle zeynepjs overlay click
        $('.zeynep-overlay').on('click', function () {
            zeynep.close()
        })

        // open zeynepjs side menu



        $(".btn-open").click(function () {
            if ($("html").hasClass("zeynep-opened")) {
                zeynep.close();
            } else {
                zeynep.open();
            }
        });

    $( "#notFoundMenuOpen" ).click(function() {
        $( ".notFoundMenuItem" ).slideDown( "slow", function() {
            // Animation complete.
        });
        $(this).hide();
    });



});



